module.exports = __webpack_public_path__ + "media/images/tiedye/design-1-36566417186bd220c48fed4424ff258c.jpg";